import { render } from "./ListeMotifSuivi.vue?vue&type=template&id=54e674b8&ts=true"
import script from "./ListeMotifSuivi.vue?vue&type=script&lang=ts"
export * from "./ListeMotifSuivi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__